import { render, staticRenderFns } from "./TheIntro.vue?vue&type=template&id=1a531a34&scoped=true"
import script from "./TheIntro.vue?vue&type=script&lang=js"
export * from "./TheIntro.vue?vue&type=script&lang=js"
import style0 from "./TheIntro.vue?vue&type=style&index=0&id=1a531a34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a531a34",
  null
  
)

export default component.exports